export const assetPrefix = process.env.PUBLIC_URL;
